module.exports = __webpack_public_path__ + "img/Wikipedia.60c412d1.png";